import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LegalPageShell from "./LegalPageShell";
import privacyEn from "./content/privacy.en";
import privacyAr from "./content/privacy.ar";

export default function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const P = i18n.language?.startsWith("ar") ? privacyAr : privacyEn;

  return (
    <LegalPageShell titleKey="legal.privacyTitle">
      <section aria-labelledby="pp-intro">
        <h2 id="pp-intro">{P.intro.h2}</h2>
        {P.intro.p.map((text, i) => (
          <p key={i}>{text}</p>
        ))}
      </section>

      <section aria-labelledby="pp-controller">
        <h2 id="pp-controller">{P.controller.h2}</h2>
        <p>{P.controller.p1}</p>
        <address>
          {P.controller.address.map((line, i) => (
            <React.Fragment key={i}>
              {i === 0 ? <strong>{line}</strong> : line}
              {i < P.controller.address.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </address>
        <p>
          {P.controller.p2.before}{" "}
          <Link to="/#contact-us">{P.controller.p2.linkLabel}</Link>{" "}
          {P.controller.p2.after}
        </p>
      </section>

      <section aria-labelledby="pp-collect">
        <h2 id="pp-collect">{P.collect.h2}</h2>

        <h3>{P.collect.provided.h3}</h3>
        <p>{P.collect.provided.p1}</p>
        <ul>
          {P.collect.provided.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{P.collect.provided.p2}</p>

        <h3>{P.collect.automated.h3}</h3>
        <p>{P.collect.automated.p1}</p>
        <ul>
          {P.collect.automated.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        <h3>{P.collect.cookies.h3}</h3>
        <p>{P.collect.cookies.p1}</p>
      </section>

      <section aria-labelledby="pp-use">
        <h2 id="pp-use">{P.use.h2}</h2>
        <p>{P.use.p1}</p>
        <ul>
          {P.use.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{P.use.p2}</p>
      </section>

      <section aria-labelledby="pp-security-monitoring">
        <h2 id="pp-security-monitoring">{P.securityMonitoring.h2}</h2>
        <p>{P.securityMonitoring.p1}</p>
      </section>

      <section aria-labelledby="pp-sharing">
        <h2 id="pp-sharing">{P.sharing.h2}</h2>
        <p>{P.sharing.p1}</p>
        <ul>
          {P.sharing.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{P.sharing.p2}</p>
      </section>

      <section aria-labelledby="pp-transfers">
        <h2 id="pp-transfers">{P.transfers.h2}</h2>
        <p>{P.transfers.p1}</p>
      </section>

      <section aria-labelledby="pp-retention">
        <h2 id="pp-retention">{P.retention.h2}</h2>
        <p>{P.retention.p1}</p>
      </section>

      <section aria-labelledby="pp-rights">
        <h2 id="pp-rights">{P.rights.h2}</h2>
        <p>{P.rights.p1}</p>
        <p>
          {P.rights.p2.before}{" "}
          <Link to="/#contact-us">{P.rights.p2.linkLabel}</Link>{" "}
          {P.rights.p2.after}
        </p>
      </section>

      <section aria-labelledby="pp-children">
        <h2 id="pp-children">{P.children.h2}</h2>
        <p>{P.children.p1}</p>
      </section>

      <section aria-labelledby="pp-changes">
        <h2 id="pp-changes">{P.changes.h2}</h2>
        <p>{P.changes.p1}</p>
      </section>

      <section aria-labelledby="pp-terms">
        <h2 id="pp-terms">{P.related.h2}</h2>
        <p>
          {P.related.p1.before ? `${P.related.p1.before} ` : null}
          <Link to="/terms-of-use">{P.related.p1.termsLink}</Link>{" "}
          {P.related.p1.after}
        </p>
      </section>
    </LegalPageShell>
  );
}
